var styles = [{
  backgroundColor: 'rgb(34, 167, 230)',
  borderColor: 'rgba(34, 167, 230, 0.48)',
  pointHoverBorderColor: 'rgb(223,239,246)'
}, {
  backgroundColor: 'rgb(92, 184, 92)',
  borderColor: 'rgba(92, 184, 92, 0.48)',
  pointHoverBorderColor: 'rgb(229,247,229)'
}, {
  backgroundColor: 'rgb(252, 198, 51)',
  borderColor: 'rgba(252, 198, 51, 0.48)',
  pointHoverBorderColor: 'rgb(246,239,220)'
}, {
  backgroundColor: 'rgb(227, 50, 68)',
  borderColor: 'rgba(227, 50, 68, 0.48)',
  pointHoverBorderColor: 'rgb(247,224,226)'
}, {
  backgroundColor: 'rgb(135, 100, 186)',
  borderColor: 'rgba(135, 100, 186, 0.48)',
  pointHoverBorderColor: 'rgb(229,219,244)'
}];
export default {
  styles: styles
};